<template>
  <b-row class="profile-show" v-if="company && user">
    <b-col :md="layout === 'modal' || layout === 'mentor' ? 12 : 12">

      <b-row class="mt-2 mb-3" v-if="profileCompletion.length && layout === 'page' && userID === user.id">
        <b-col>
          <b-alert show dismissible>
            <p><span class="pr-2">👋</span>We have noticed that you have not yet completed your profile. Here are some of our recommendations to help you get the most out of this platform.</p>
            <ul>
              <li v-for="recommendation in profileCompletion" :key="recommendation">
                <template v-if="recommendation === 'NO_JOB_TITLE'">Set your current job title to keep your profile up-to-date</template>
                <template v-else-if="recommendation === 'NO_CURRENT_SKILLS'">Set your current skills so we can match you to relevant opportunities</template>
                <template v-else-if="recommendation === 'NOT_ENOUGH_CURRENT_SKILLS'">Add more skills you currently have so we can match you to relevant opportunities</template>
                <template v-else-if="recommendation === 'NO_DEVELOPMENT_SKILLS'">Set the skills you want to develop, so we can match you to relevant projects and mentors</template>
                <template v-else-if="recommendation === 'NOT_ENOUGH_DEVELOPMENT_SKILLS'">Add more skills you want to develop, so we can show you relevant projects and mentors</template>
                <template v-else-if="recommendation === 'NO_BUSINESS_AREA'">Select at least one area of business you are interested in, so we can show you opportunities tailored to your interests</template>
              </li>
            </ul>
          </b-alert>
        </b-col>
      </b-row>

      <!-- First Top Left Row -->
      <b-row>

        <!-- Top Left Block -->
        <b-col class="pb-3" :md="layout === 'modal' || layout === 'mentor' ? 12 : 6">
          <b-card class="h-100" body-class="d-flex align-items-center">
            <b-row class="w-100">
              <b-col cols="3" class="d-flex justify-content-center align-items-center">
                <avatar :user="user" :size="42"/>
              </b-col>
              <b-col cols="9">
                <b>{{user.fullName}}</b><br>
                <span class="text-muted" v-if="jobTitle">{{jobTitle}}</span>
                <template v-if="user.resume && user.resume.fileLocation">
                  <br><a :href="user.resume.fileLocation" target="_blank">See Resume</a>
                </template>
                <span class="text-muted pl-4" v-if="user.location">
                  <font-awesome-icon icon="map-marker" style="color: #bbb"/> {{user.location.name}}
                </span>
              </b-col>
            </b-row>
            <b-row v-if="/* layout === 'modal' || */layout === 'mentor'" class="pt-4">
              <b-col>
                <b-button variant="primary" @click="$emit('contactMentor')" block>{{ isCXR ? 'Connect' : 'Contact' }}</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <!-- Second Left Block -->
        <b-col class="pb-3" v-if="message" :md="layout === 'modal' || layout === 'mentor' ? 12 : 6">
          <b-card class="h-100">
            <b-row class="pb-3 border-bottom">
              <b-col class="block-title">Application Message</b-col>
            </b-row>
            <b-row v-if="user.emailAddress" class="pt-3">
              <b-col>{{ message }}</b-col>
            </b-row>
          </b-card>
        </b-col>

        <!-- Second Left Block -->
        <b-col
          class="pb-3" v-if="isRecruiter || user.id === userID"
          :md="layout === 'modal' || layout === 'mentor' ? 12 : 6"
        >
          <b-card class="h-100">
            <b-button
              v-if="layout !== 'modal' && layout !== 'mentor'"
              size="sm"
              class="edit-button"
              variant="link"
              @click="$emit('openEditAccountModal')"
            >
              Edit Account
            </b-button>
            <b-row class="pb-3 border-bottom">
              <b-col class="block-title">Contact Info</b-col>
            </b-row>
            <b-row v-if="user.emailAddress" class="pt-3">
              <b-col>
                <b>Email</b><br>
                <span class="text-muted">{{user.emailAddress}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.phone" class="pt-3">
              <b-col>
                <b>Email</b><br>
                <span class="text-muted">{{user.phone}}</span>
              </b-col>
            </b-row>
            <b-row v-if="Array.isArray(user.departments) && user.departments.length" class="pt-3">
              <b-col>
                <b>Department(s)</b><br>
                <span class="text-muted">{{user.departments.map(el => el.name || '-').join(', ')}}</span>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- Dynamic blocks -->
      <b-row>
        <b-col
            v-for="group in groups.filter(({ name } = {}) => (layout === 'modal' && name !== 'jobs') || (layout === 'mentor' && (name === 'mentorship' || name === 'skills')) || layout === 'page')"
            v-if="(Array.isArray(customFields) ? customFields : []).filter(el => el.group === group.name && values[el.key]).length"
            :key="group.name"
            class="pb-3"
            :md="layout === 'modal' || layout === 'mentor' ? 12 : 6"
          >
          <b-card class="h-100">
            <b-button
              v-if="layout !== 'modal' && layout !== 'mentor'"
              size="sm"
              class="edit-button"
              variant="link"
              @click="$emit('openEditModal', editModalContent(group.name))"
            >
              Edit
            </b-button>
            <b-row class="pb-3 border-bottom">
              <b-col cols="12" class="block-title">{{group.name === 'jobs' ? 'Jobs you\'re interested in' : group.displayName}}</b-col>
            </b-row>
            <div>
              <custom-field-block
                v-for="field in customFields.filter(el => el.group === group.name && (!el.key.includes('QUALIFICATION') && !el.key.includes('DEVELOP') || layout !== 'mentor'))"
                v-if="!field.key.includes('TALENT') || (field.key.includes('TALENT') && user.isTalent)"
                :key="field.key"
                :field="field"
                :value="values[field.key]"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="user.restrictedData">
        <b-col>
          <b-card>
            <b-row class="pb-3 border-bottom">
              <b-col class="block-title">Additional Information (Only visible to Admins)</b-col>
            </b-row>
            <b-row v-if="user.restrictedData.potential" class="pt-3">
              <b-col>
                <b>Potential</b><br>
                <span class="text-muted">{{user.restrictedData.potential}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.yearsWithRole" class="pt-3">
              <b-col>
                <b>Years with Role</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.yearsWithRole}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.futureMobility" class="pt-3">
              <b-col>
                <b>Future Mobility</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.futureMobility}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.inCriticalRole" class="pt-3">
              <b-col>
                <b>In Critical Role</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.inCriticalRole}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.inHardToFillRole" class="pt-3">
              <b-col>
                <b>In Hard to Fill Role</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.inHardToFillRole}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.yearsWithCompany" class="pt-3">
              <b-col>
                <b>Years with Company</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.yearsWithCompany}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.additionalDetails" class="pt-3">
              <b-col>
                <b>Additional Details</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.additionalDetails}}</span>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.potentialSuccessors && JSON.parse(user.restrictedData.potentialSuccessors).length" class="pt-3">
              <b-col>
                <b>Potential Successors</b><br>
                <template v-for="successor in JSON.parse(user.restrictedData.potentialSuccessors)">
                  <span class="text-muted text-nowrap">{{successor.name}} ({{successor.readinessInYear}})</span><br>
                </template>
              </b-col>
            </b-row>
            <b-row v-if="user.restrictedData.developmentActivityUnderway" class="pt-3">
              <b-col>
                <b>Development Activity Underway</b><br>
                <span class="text-muted text-nowrap">{{user.restrictedData.developmentActivityUnderway}}</span>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import tinycolor from 'tinycolor2';
import { onboardingSteps } from '@/views/onboarding/index';
import Avatar from '@/components/users/Avatar';
import CustomFieldBlock from '@/components/profile/CustomFieldBlock';
import ApplicationCard from '@/components/profile/ApplicationCard.vue';
import MentorRequestCard from '@/components/profile/MentorRequestCard.vue';
import MenteeRequestCard from '@/components/profile/MenteeRequestCard.vue';
import { parseIfPossible } from '@src/lib/imMatching';

export default {
  name: 'ProfileShow',
  components: {
    Avatar,
    CustomFieldBlock,
    ApplicationCard,
    MentorRequestCard,
    MenteeRequestCard,
  },
  props: {
    user: {
      type: Object,
      default: () => null
    },
    message: {
      type: String,
      default: () => null
    },
    layout: {
      type: String,
      default: 'page',
    }
  },
  mounted() {
    console.log('USER: ', this.user);
  },
  computed: {
    ...mapRoot([ 'isRecruiter', 'userID', 'company', 'isCXR' ]),
    groups() {
      const { siteBranding: { onboarding } = {} } = this.company || {};
      const groups = (Array.isArray(onboarding) ? onboarding : []).map(({ name } = {}) => onboardingSteps.find(group => group.name === name));
      return groups.filter(({ name } = {}) => [ 'skills', 'jobs', 'development', 'mentorship', 'interest', 'mentorpreferences', 'career' ].includes(name));
    },
    values() {
      const { user, parseIfPossible } = this;
      if (user && Array.isArray(user.customFields) && user.customFields.length) {
        const values = user.customFields.reduce((values, { key, value }) => Object.assign(values, { [key]: parseIfPossible(value) }), {});
        console.log('VALUES: ', values);
        return values;
      }
      return null;
    },
    customFields() {
      const { customFields } = this.company || {};
      const userDepartments = Array.isArray(this.user.departments) ? this.user.departments.map(({ id }) => id) : [];
      const fields = (Array.isArray(customFields) ? customFields : []).map(({ options, departments, ...field }) => {
        options = parseIfPossible(options);
        return {
          ...field,
          options,
          departments: departments ? departments.map(({ id }) => id) : null,
        };
      }).filter(({ departments }) => departments ? departments.filter(el => userDepartments.includes(el)).length : true);
      console.log('FIELDS: ', fields);
      return fields;
    },
    jobSelections() {
      if (this.values) {
        const jobSelections = this.parseIfPossible(this.values['EMPLOYEE-JOB-SELECTIONS']);
        console.log('JOB SELECTIONS: ', jobSelections);
        return jobSelections || [];
      }
      return [];
    },
    jobTitle() {
      return this.getFieldValue('JOB_TITLES', 'skills');
    },
    tagBackgroundColour() {
      const { siteBranding } = this.company;
      return siteBranding && siteBranding.primaryColour ? tinycolor(siteBranding.primaryColour).lighten(42).toString() : '#eee';
    },
    profileCompletion() {
      const { company: { customFields: companyCustomFields } = {}, user: { customFields: userCustomFields = [] } = {} } = this;
      const recommendations = [];
      if (Array.isArray(companyCustomFields) && Array.isArray(userCustomFields)) {
        companyCustomFields.forEach(({ key, type, group }) => {
          const userField = userCustomFields.find(el => el.key === key);
          const value = parseIfPossible(userField ? userField.value : null);
          const isValueNull = !value;
          const isValueEmpty = !Array.isArray(value) || value.length === 0;
          const isValueNotSufficient = len => Array.isArray(value) && value.length < len;
          if (group === 'skills' && type === 'JOB_TITLES' && isValueNull) {
            recommendations.push('NO_JOB_TITLE');
          } else if (group === 'skills' && type === 'JOB_SKILLS') {
            console.log('VALUE: ', value);
            if (isValueEmpty) {
              recommendations.push('NO_CURRENT_SKILLS');
            } else if (isValueNotSufficient(4)) {
              recommendations.push('NOT_ENOUGH_CURRENT_SKILLS');
            }
          } else if (group === 'skills' && type === 'JOB_DEVELOPMENT_SKILLS') {
            if (isValueEmpty) {
              recommendations.push('NO_DEVELOPMENT_SKILLS');
            } else if (isValueNotSufficient(4)) {
              recommendations.push('NOT_ENOUGH_DEVELOPMENT_SKILLS');
            }
          } else if (group === 'interest' && type === 'JOB_BUSINESS_AREA' && isValueEmpty) {
            recommendations.push('NO_BUSINESS_AREA');
          }
        });
      }
      // console.log({ companyCustomFields, userCustomFields });
      return recommendations;
    },
  },
  methods: {
    getFieldValue(type, group) {
      const { company: { customFields }, user: { customFields: userCustomFields } } = this;
      if (Array.isArray(customFields) && customFields.length && Array.isArray(userCustomFields)) {
        const field = customFields.find(el => el.type === type && el.group === group);
        const fieldKey = field ? field.key : null;
        const userField = fieldKey ? userCustomFields.find(({ key }) => key === fieldKey) : null;
        return userField ? userField.value : null;
      }
      return null;
    },
    parseIfPossible(value) {
      try {
        value = JSON.parse(value);
      } catch (e) {
        // not a json
      }
      return value;
    },
    editModalContent(groupName) {
      const { values, customFields } = this;
      const fields = customFields.filter(el => el.group === groupName);
      return {
        name: groupName,
        fields,
        values,
      };
    },
  }
};
</script>

<style lang="scss">
.profile-show {
  .edit-button {
    position: absolute;
    right: 10px;
    top: 13px;
    z-index: 10;
  }
  .block-title {
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/ProfileShow.vue